
import btn from '../components/btn'
import { mapGetters } from 'vuex'

export default {
	name: 'BindAccount',
	components: {
		btn
	},
	props: {
		content: {
			type: Object,
			default: () => ({})
		},
		mentionedUser: {
			type: String,
			default: ''
		},
		displayData: {
			type: Object,
			default: () => ({})
		},
		canSeeBtns: {
			type: Boolean,
			default: false
		},
		expansion: {
			type: Object,
			default: () => ({})
		}
	},
	data() {
		return {}
	},
	computed: {
		...mapGetters({
			orderInfo: 'ry/imOrderInfo'
		})
	},
	mounted() {
		console.log(this.content)
		console.log(this.canSeeBtns)
		console.log(this.expansion)
		console.log('订单信息：', this.orderInfo)
	},
	beforeDestroy() {},
	methods: {
		clickBtn(index) {
			this.$emit('workOrderClick', this.content.buttons[index], index)
		}
	}
}
